import * as productHelpers from '@/helpers/product-sort-filter.js'

export default {
  getCategory: state => {
    let category = {
      name: '',
      slug: '',
      description: '',
      image: []
    }

    if (state.category === 'all') {
      return {
        name: 'All',
        slug: 'all',
        description: '',
        image: []
      }
    }

    if (!state.categories) {
      return category
    }

    const foundCategory = state.categories.filter(
      category => category.slug === state.category
    )

    if (foundCategory.length > 0) {
      return foundCategory[0]
    }

    return category
  },

  findProduct: state => id => {
    if (state.all.length > 0) {
      return state.all.find(item => item.id === id) || false
    }

    return undefined
  },

  findProductByVariant: state => id => {
    if (state.all.length > 0) {
      return (
        state.all.find(item => item.prices.find(price => price.id === id)) ||
        false
      )
    }

    return undefined
  },

  collectProducts: state => ids => {
    if (state.all.length > 0) {
      return state.all.filter(item => ids.includes(item.id)) || false
    }

    return undefined
  },

  collectProductsByVariants: state => ids => {
    if (state.all.length > 0) {
      return (
        state.all.filter(item =>
          item.prices.find(price => ids.includes(price.id))
        ) || false
      )
    }

    return undefined
  },

  getProducts: state => {
    let results = state.all

    if (!results) {
      return results
    }

    if (state.category !== 'all') {
      results = results.filter(product => {
        return product.category === state.category
      })
    }

    if (state.search) {
      results = results.filter(product => {
        return productHelpers.productHasSearchValue(product, state.search)
      })
    }

    results = results.filter(product => {
      return productHelpers.productHasFilterValues(product, state.filters)
    })

    if (state.sort.field) {
      let sortMethod = productHelpers.sortByField

      switch (state.sort.field) {
        case 'thc':
          sortMethod = productHelpers.sortByTHC
          break
        case 'cbd':
          sortMethod = productHelpers.sortByCBD
          break
        case 'price':
          sortMethod = productHelpers.sortByPrice
          break
        default:
          break
      }

      results = results.sort((a, b) => {
        return productHelpers.sortDirection(
          sortMethod(a, b, state.sort.field),
          state.sort.dir
        )
      })
    }

    return results
  },

  getStrains: state => {
    let strains = state.all.reduce((previous, current) => {
      if (current.strain && !previous.includes(current.strain)) {
        previous.push(current.strain)
      }
      return previous
    }, [])

    strains = strains.sort()

    return strains
  },

  getBrands: state => {
    let brands = state.all.reduce((previous, current) => {
      if (current.brand && !previous.includes(current.brand)) {
        previous.push(current.brand)
      }
      return previous
    }, [])

    brands = brands.sort()

    return brands
  },

  getPriceRange: state => {
    const prices = state.all.reduce(productHelpers.reducePriceRange, [
      Infinity,
      0
    ])

    return [Math.floor(prices[0] / 100), Math.ceil(prices[1] / 100)]
  },

  getActiveFilters: state => {
    const filters = state.filters
    const activeFilters = []
    let priceRange = []

    if (filters.priceRange.length === 2) {
      const low = filters.priceRange[0]
      const high = filters.priceRange[1]

      priceRange =
        low !== state.priceRange[0] || high !== state.priceRange[1]
          ? [...filters.priceRange]
          : []
    }

    if (priceRange.length === 2) {
      activeFilters.push({
        label: `$${priceRange[0]} - $${priceRange[1]}`,
        field: 'priceRange',
        value: priceRange
      })
    }

    activeFilters.push(
      ...filters.brand.reduce((previous, brand) => {
        previous.push({
          label: brand,
          field: 'brand',
          value: brand
        })
        return previous
      }, [])
    )

    activeFilters.push(
      ...filters.strain.reduce((previous, strain) => {
        previous.push({
          label: strain,
          field: 'strain',
          value: strain
        })
        return previous
      }, [])
    )

    return activeFilters
  }
}
